import { httpApi } from "./http.api";
import {OrderPayload, PromoCode} from "../@types/signup";

interface ValidateResponse {
    valid: boolean;
    message: string;
}

interface ValidatePromoCodeResponse {
    valid: boolean;
    promo: PromoCode | null;
    message?: string;
}

interface GenericResponse {
    success: boolean;
    message: string;
}

export const validatePhoneNumber = async (value: string): Promise<ValidateResponse> => {
    return await httpApi.post<ValidateResponse>(`/validate/phone`, { value }).then(({ data }) => data);
};

export const validatePromoCode = async (promoCode: string, broadbandPlanUuid?: string): Promise<ValidatePromoCodeResponse> => {
    return await httpApi.post<ValidatePromoCodeResponse>(`/validate/promo-code`, { 
        promo_code: promoCode,
        broadband_plan_uuid: broadbandPlanUuid
    }).then(({ data }) => data);
};

export const submitOrder = async (payload: OrderPayload): Promise<GenericResponse> => {
    return await httpApi.post<GenericResponse>(`/order/submit`, { payload }).then(({ data }) => data);
};
